/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import Config from "data/config";
import DisplayTextOnly from "cms/fields/layout/controls/display-text-only";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import useOrganization from "hooks/useOrganization";
import dayjs from "dayjs";
import { Fragment } from "react";
import { Logger } from "cms/utils/log/logger";

const DISPLAY_FORMAT = Config.dates.display.date;
const STORAGE_FORMAT = Config.dates.internalFormats.date;
const SCHEMA = {
    "field.format.numeric": { "name":"YYYY-MM-DD (2000-01-30)","description":"Numeric","value":"field.format.numeric","format":"YYYY-MM-DD" },
    "field.format.short": { "name":"DD MMM (30 Jan)","description":"Short","value":"field.format.short","format":"DD MMM" },
    "field.format.shortyear": { "name":"DD MMM YYYY (30 Jan 2000)","description":"Short+Year","value":"field.format.shortyear","format":"DD MMM YYYY" },
    "field.format.business": { "name":"dddd, MMMM D (Monday, January 1)","description":"Business","value":"field.format.business","format":"dddd, MMMM D" },
    "field.format.businessyear": { "name":"dddd, MMMM D, YYYY (Monday, January 1, 2000)","description":"Business+Year","value":"field.format.businessyear","format":"dddd, MMMM D, YYYY" },
    "field.format.none": DISPLAY_FORMAT,   // use default
};

// FIXME: need to match the 'value' property of real schema and get 'format' from real schema
const FORMATS = {
    "field.format.numeric": SCHEMA["field.format.numeric"].format,
    "field.format.short": SCHEMA["field.format.short"].format,
    "field.format.shortyear": SCHEMA["field.format.shortyear"].format,
    "field.format.business": SCHEMA["field.format.business"].format,
    "field.format.businessyear": SCHEMA["field.format.businessyear"].format,
    "field.format.none": DISPLAY_FORMAT,   // use default
};

const getFormat = (format) =>  {
    let formatDef = FORMATS[format];
    if (!formatDef) {
        formatDef = DISPLAY_FORMAT;
    }
    return formatDef;
};

const DateFieldDisplay = () => {
    
    const organization = useOrganization() || {};
    const { field } = useCurrentDynamicField();

    const { values } = field || {};
    // const { format } = settings || {}  // format will be the name of an option fields.format._____
    
    return (
        <FieldDisplayWrapper>
            {values &&
                values.length > 0 &&
                values.map((item, index) => {
                    const { value, settings } = item || {};
                    const { tz: orgTimezone } = organization || {};
                    const { date, tz = orgTimezone } = value || {};
                    const { style, format, options } = settings || {};
                    const dateFormat = getFormat(format);
                    let dateVal = "";
                    try {
                        const dateInZone = dayjs.tz(date, STORAGE_FORMAT, tz);
                        dateVal = date ? dateInZone.format(dateFormat) : "";
                    } catch (e) {
                        Logger.error(e);
                        return null;
                    }
                    
                    return (
                        <Fragment key={index}>
                            <DisplayTextOnly value={dateVal} style={style} format={format} options={options} />
                        </Fragment>
                    );
                })}
        </FieldDisplayWrapper>
    );
};
DateFieldDisplay.displayName = "DateFieldDisplay";
export { DateFieldDisplay };
